import { addRole } from "./add-role";
import { createPrivateChat } from "./private-ticket";

export function discord() {
  addRole();
  createPrivateChat();
}
